import { Link } from "react-router-dom"

const Footer = () => {
    return (
       <>  <footer className="footer-area">
       <div className="footer-widget">
           <div className="container">
               <div className="row footer-widget-wrapper pt-120 pb-70">
                   <div className="col-md-6 col-lg-4">
                       <div className="footer-widget-box about-us">
                           <a href="#" className="footer-logo">
                               <img src="/assets/img/logo/logo-light.png" />
                           </a>
                           <p className="mb-3">
                           At Cars53, we understand the importance of quick availability. That's why our fleet of amazing cars and experienced drivers are always ready to pick you up whenever you need a ride. Whether you're heading to the airport, the office, or a night out on the town, Cars53 has you covered.
                           </p>
                           <ul className="footer-contact">
                               <li><a href="tel:+919479525453"><i className="far fa-phone"></i>+91 94795 25453</a></li>
                               <li><i className="far fa-map-marker-alt"></i>Ratlam, MP, India</li>
                               <li><a
                                   href="mailto:car53app@gmail.com"><i
                                       className="far fa-envelope"></i><span className="__cf_email__"
                                           >car53app@gmail.com</span></a>
                               </li>
                           </ul>
                       </div>
                   </div>
                   <div className="col-md-6 col-lg-2">
                       <div className="footer-widget-box list">
                           <h4 className="footer-widget-title">Quick Links</h4>
                           <ul className="footer-list">
                               <li><Link to="/about"><i className="fas fa-caret-right"></i> About Us</Link></li>
                               <li><Link to="/terms"><i className="fas fa-caret-right"></i> Terms Of Service</Link></li>
                               <li><Link to="/privacy"><i className="fas fa-caret-right"></i> Privacy policy</Link></li>
                           </ul>
                       </div>
                   </div>
                   <div className="col-md-6 col-lg-3">
                       <div className="footer-widget-box list">
                           <h4 className="footer-widget-title">Support Center</h4>
                           <ul className="footer-list">
                               <li><a href="https://partner.cars53.in" target="_blank"><i className="fas fa-caret-right"></i> Become a Partner</a></li>
                               
                               <li><Link to="/taxi"><i className="fas fa-caret-right"></i> Book A Ride</Link></li>
                               <li><Link to="/contact"><i className="fas fa-caret-right"></i> Contact Us</Link></li>
                           </ul>
                       </div>
                   </div>
                   <div className="col-md-6 col-lg-3">
                       <div className="footer-widget-box list">
                           <h4 className="footer-widget-title">Newsletter</h4>
                           <div className="footer-newsletter">
                               <p>Subscribe Our Newsletter To Get Latest Update And News</p>
                               <div className="subscribe-form">
                                   <form action="#">
                                       <input type="email" className="form-control" placeholder="Your Email" />
                                       <button className="theme-btn" type="submit">
                                           Subscribe Now <i className="far fa-paper-plane"></i>
                                       </button>
                                   </form>
                               </div>
                           </div>
                       </div>
                   </div>
               </div>
           </div>
       </div>
       <div className="copyright">
           <div className="container">
               <div className="row">
                   <div className="col-md-6 align-self-center">
                       <p className="copyright-text">
                           &copy; Copyright <span id="date"></span> <a href="#"> Cars53 </a> All Rights Reserved.
                       </p>
                   </div>
                   <div className="col-md-6 align-self-center">
                       <ul className="footer-social">
                           <li><a href="#"><i className="fab fa-facebook-f"></i></a></li>
                           <li><a href="#"><i className="fab fa-twitter"></i></a></li>
                           <li><a href="#"><i className="fab fa-linkedin-in"></i></a></li>
                           <li><a href="#"><i className="fab fa-youtube"></i></a></li>
                       </ul>
                   </div>
               </div>
           </div>
       </div>
   </footer>


   <a href="#" id="scroll-top"><i className="far fa-arrow-up"></i></a></> 
    )
    }
    export default Footer